import * as React from 'react';

var Tooltip = function (props) {
    return React.createElement("div", { className: props.className || '' }, props.children);
};

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
